import React from 'react'
import { Table, CustomInput, Input } from 'reactstrap'
import styled from 'styled-components'
import get from 'lodash/get'
import shortid from 'shortid'
import NumberFormat from 'react-number-format'
import TrashDefault from '../../../../static/images/trash-default.svg'
import TrashHover from '../../../../static/images/trash-hover.svg'
import { licensing_table_header, license_type } from '../../constants'
import { FONTS } from '../../../../constants'

export default class LicensingTable extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props)) return false
    return true
  }

  filterLicensing = (element) => {
    const search_license = get(this.props, 'search_license', '')
    if (search_license !== '' && element) {
      const name = element.name.toLowerCase()
      const description = element.description.toLowerCase()
      const type = element.type.toLowerCase()
      const sub_project_code = element.sub_project_code.toLowerCase()
      return name.includes(search_license.toLowerCase())
      || description.includes(search_license.toLowerCase())
      || type.includes(search_license.toLowerCase())
      || sub_project_code.includes(search_license.toLowerCase())
      || type.includes(search_license.toLowerCase())
    } return element
  }

  render() {
    const editLicense = get(this.props, 'editLicense')
    const projectByID = get(this.props, 'projectByID')
    const presale_snapshot = get(projectByID, 'presale_snapshot.snapshot')
    const rSelected = get(this.props, 'rSelected')
    const isPresale = presale_snapshot && rSelected === 1
    const licenses = !isPresale ? get(this.props, 'licenses', []) : get(presale_snapshot, 'licenses')
    const deleteLicense = get(this.props, 'deleteLicense')
    const handleChangeCost = get(this.props, 'handleChangeCost')
    return (
    /* eslint no-underscore-dangle: 0 */
      <TableDiv>
        <NewTable bordered>
          <Header>
            <tr style={ { fontFamily: 'Gotham' } }>
              { licensing_table_header.map(v => {
                  return (
                    <th key={ shortid() }>{ v.label }</th>
                  )
                })
              }
            </tr>
          </Header>
          <BodyTable>
            { licenses.filter(this.filterLicensing).map((license, key) => {
                return (
                  <tr key={ shortid() }>
                    <td>
                      <CustomInputField
                        id={ key }
                        type="select"
                        name="type"
                        disabled={ !editLicense }
                        defaultValue={ license.type }
                        onBlur={ (e) => handleChangeCost(e) }
                      >
                        { license_type.map((t) =>
                            <option key={ shortid() } value={ t.value }>{ t.label }</option>
                          )
                        }
                      </CustomInputField>
                    </td>
                    <td>
                      <InputField
                        id={ key }
                        name='sub_project_code'
                        disabled={ !editLicense }
                        defaultValue={ license.sub_project_code }
                        onBlur={ (e) => handleChangeCost(e) }
                      />
                    </td>
                    <td>
                      <InputField
                        id={ key }
                        name='name'
                        disabled={ !editLicense }
                        defaultValue={ license.name }
                        onBlur={ (e) => handleChangeCost(e) }
                      />
                    </td>
                    <td>
                      <InputField
                        id={ key }
                        name='description'
                        disabled={ !editLicense }
                        defaultValue={ license.description }
                        onBlur={ (e) => handleChangeCost(e) }
                      />
                    </td>
                    <td>
                      <NumberField
                        id={ key }
                        name='cost'
                        disabled={ !editLicense }
                        value={ license.cost }
                        thousandSeparator={ true }
                        allowEmptyFormatting={ true }
                        decimalScale={ 2 }
                        fixedDecimalScale={ true }
                        onBlur={ (e) => {
                          // e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                          handleChangeCost(e)}  }
                      />
                    </td>
                    <td>
                      <NumberField
                        id={ key }
                        name='price'
                        disabled={ !editLicense }
                        value={ license.price }
                        thousandSeparator={ true }
                        allowEmptyFormatting={ true }
                        decimalScale={ 2 }
                        fixedDecimalScale={ true }
                        onBlur={ (e) => {
                          // e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                          handleChangeCost(e)}  }
                      />
                    </td>
                    <td>
                      <Trash
                        onClick={
                          editLicense ?
                            () => deleteLicense(key)
                            : () => { }
                        }
                        edit={editLicense}
                      />
                    </td>
                  </tr>
                )
              })
            }
          </BodyTable>
        </NewTable>
      </TableDiv>
    )
  }
}

const NewTable = styled(Table)`
  background: white;
  margin-bottom: 10%;
  thead, tbody tr{
    display:table;
    width:100%;
    table-layout:fixed;
  }thead th {
    background-color:#404040 ;
    font-family: ${FONTS.GOTHAM_MEDIUM} !important;
    font-size: ${FONTS.SMALL_SIZE};
    border: none ;
  }
  @media (max-width: 575.98px) {
    width:800px;
  thead, tbody tr{
    display:table;
    width:100%;
    table-layout:fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  }
  td {
    padding-left: 1%;
  }
  th {
      padding-left: 1% ;
    }
  }
  @media (max-width: 767.98px) {
    width:800px;
  td {
    padding-left: 1%;
  }
  th {
    padding-left: 1% ;
  }
  }
  @media (max-width: 991.98px) {
    width:800px;
  td {
    padding-left: 1%;
  }
  th {
    padding-left: 1% ;
  }
  }
`
const BodyTable = styled.tbody`
  @media (max-width: 575.98px) {
    max-height: calc(100vh - 300px);
  }
  @media (max-width: 767.98px) {
    max-height: calc(100vh - 300px);
  }
  width: 100% ;
  display: block ;
  max-height: calc(100vh - 238px);
  overflow-y:scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`
const TableDiv = styled.div`
  padding-bottom: 30px;
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  @media (max-width: 575.98px) {
    padding-right: 0px;
    padding-left: 0px;
    font-size: 12px;
    width:100vw;
    overflow:scroll;
  }
  @media (max-width: 767.98px) {
    padding-right: 0px;
    padding-left: 0px;
    font-size: 12px;
    width:100vw;
    overflow:scroll;
  }
`
const Header = styled.thead`
  background: black;
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`
const InputField = styled(Input)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  width : 100% ;
  height : 100% ;
`
const NumberField = styled(NumberFormat)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  width : 80% ;
  margin-left: 10% ;
  margin-right: 10% ;
  border-radius: 5px;
  text-align:right;
  border: 1px solid #CCCCCC;
  background-color: ${props => {
  const status = props.disabled
  if (status === !get(this.props, 'editLicense')) {
    return '#E8ECEF'
  }
  return '#FFFFFF'
  }};
`
const Trash = styled.div`
  background-image: ${props => {
  const edited = props.edit
  if (edited) {
    return `url(${TrashHover})`
  }
  return `url(${TrashDefault})`
}};
  background-repeat: no-repeat;
  align-self: center;
  border:0;
  width: 20px ;
  height: 20px ;
  margin: auto ;
  cursor: ${props => { return props.edit ? 'pointer' : 'default' }};
`
const CustomInputField = styled(CustomInput)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  width : 100% ;
  height : 100% ;
`



// WEBPACK FOOTER //
// ./src/components/project-information/table/table-licensing/index.js